import { ISolicitationViewModel } from 'viewModels';
import { HistoryType } from '../../types/enums';
import { LineDate } from '../LineDate';
import { Container } from './styles';

interface EditHistoryProps {
  solicitation: ISolicitationViewModel;
}

export function EditHistory({ solicitation }: EditHistoryProps) {
  // Filter only UPDATE_SOLICITATION history entries
  const editHistory = solicitation.history?.filter(
    (h) => h.type === HistoryType.UPDATE_SOLICITATION,
  ) || [];

  if (editHistory.length === 0) {
    return null;
  }

  return (
    <Container>
      <h2>Histórico de Edições</h2>
      <div className="history-scroll">
        {editHistory.map((history) => (
          <div className="historyItem" key={history.id}>
            <LineDate date={history.createdAt} />
            <div className="historyItemContainer">
              <div className="historyItemContent">
                <p className="historyText">
                  <strong>{history.createdBy}</strong> editou a solicitação
                </p>
                {history.text && (
                  <div className="changesList">
                    {history.text
                      .split('Alterações: ')[1]
                      ?.split('; ')
                      .map((change, index) => (
                        <div key={index} className="changeItem">
                          • {change}
                        </div>
                      ))}
                  </div>
                )}
                {history.prevSolicitationValue !== undefined &&
                  history.newSolicitationValue !== undefined && (
                    <p className="valueChange">
                      Valor alterado de{' '}
                      {new Intl.NumberFormat('pt-BR', {
                        style: 'currency',
                        currency: 'BRL',
                      }).format(history.prevSolicitationValue)}{' '}
                      para{' '}
                      {new Intl.NumberFormat('pt-BR', {
                        style: 'currency',
                        currency: 'BRL',
                      }).format(history.newSolicitationValue)}
                    </p>
                  )}
                {history.prevSolicitationDateLimit &&
                  history.newSolicitationDateLimit && (
                    <p className="dateChange">
                      Data limite alterada de{' '}
                      {new Date(history.prevSolicitationDateLimit).toLocaleDateString('pt-BR', {
                        day: 'numeric',
                        month: 'long',
                        year: 'numeric',
                        hour: 'numeric',
                        minute: 'numeric',
                      })}{' '}
                      para{' '}
                      {new Date(history.newSolicitationDateLimit).toLocaleDateString('pt-BR', {
                        day: 'numeric',
                        month: 'long',
                        year: 'numeric',
                        hour: 'numeric',
                        minute: 'numeric',
                      })}
                    </p>
                  )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </Container>
  );
}
